import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d5c43be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lang_select_div" }
const _hoisted_2 = { class: "icon_languages languages_box" }

import store  from '@/store'
import { computed, defineComponent, reactive, ref, Ref, PropType , watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { ElMessage } from 'element-plus'
import { setLanguage,getLanguage } from '@/utils/cookies'
type Language = {
    name: string
    value: string
}

  
export default /*#__PURE__*/_defineComponent({
  props: {
    color: {
      type: Object as PropType<String>,
      required: false,
    }
  },
  setup(__props) {

const props = __props



  const { locale } = useI18n()
  store.dispatch('setLanguages', locale.value) 
  const languages: Ref<Array<Language>> = ref([{ name: 'English - EN', value: 'en' }, { name: '简体中文 - ZH', value: 'zh-cn' }] as Array<Language>)
 watch(()=>locale.value,() => {
    store.dispatch('setLanguages', locale.value) 
    ElMessage({
      message: 'Switch Language Success',
      type: 'success'
    })
  }) 
  

 
    
  // const iconUrl = computed(() => {
  //   return locale.value == 'en' ? 'https://image.kilimall.com/seller/en_2x.png':'https://image.kilimall.com/seller/zh_cn_2x.png'
  // })
  
  const languagesText = computed(() => {
    return locale.value == 'en' ? 'EN':'ZH'
  })
  const language = computed(() => {
    return store.getters.language
  })
 
  
  const color = props.color ||  'white'


return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dropdown, { trigger: "click" }, {
      dropdown: _withCtx(() => [
        _createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(languages.value, (item) => {
              return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                key: item.value,
                disabled: _unref(language)===item.value
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio, {
                    modelValue: _unref(locale),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(locale) ? (locale).value = $event : null)),
                    label: item.value,
                    size: "large"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "label"])
                ]),
                _: 2
              }, 1032, ["disabled"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(languagesText)), 1)
      ]),
      _: 1
    })
  ]))
}
}

})